/*
 * The typography values for Devanagari and Gurmukhi characters are identical
 */

const devanagari = {
  atlas: {
    groupA: {
      fontSize: 78,
      lineHeight: 84,
    },
    groupB: {
      fontSize: 96,
      lineHeight: 104,
    },
    groupD: {
      fontSize: 140,
      lineHeight: 148,
    },
  },
  elephant: {
    groupA: {
      fontSize: 60,
      lineHeight: 64,
    },
    groupB: {
      fontSize: 78,
      lineHeight: 84,
    },
    groupD: {
      fontSize: 116,
      lineHeight: 124,
    },
  },
  imperial: {
    groupA: {
      fontSize: 50,
      lineHeight: 54,
    },
    groupB: {
      fontSize: 64,
      lineHeight: 72,
    },
    groupD: {
      fontSize: 96,
      lineHeight: 104,
    },
  },
  royal: {
    groupA: {
      fontSize: 40,
      lineHeight: 44,
    },
    groupB: {
      fontSize: 52,
      lineHeight: 60,
    },
    groupD: {
      fontSize: 76,
      lineHeight: 84,
    },
  },
  foolscap: {
    groupA: {
      fontSize: 32,
      lineHeight: 36,
    },
    groupB: {
      fontSize: 40,
      lineHeight: 44,
    },
    groupD: {
      fontSize: 56,
      lineHeight: 60,
    },
  },
  canon: {
    groupA: {
      fontSize: 28,
      lineHeight: 36,
    },
    groupB: {
      fontSize: 36,
      lineHeight: 46,
    },
    groupD: {
      fontSize: 44,
      lineHeight: 58,
    },
  },
  trafalgar: {
    groupA: {
      fontSize: 20,
      lineHeight: 30,
    },
    groupB: {
      fontSize: 24,
      lineHeight: 36,
    },
    groupD: {
      fontSize: 32,
      lineHeight: 44,
    },
  },
  paragon: {
    groupA: {
      fontSize: 20,
      lineHeight: 28,
    },
    groupB: {
      fontSize: 22,
      lineHeight: 32,
    },
    groupD: {
      fontSize: 28,
      lineHeight: 42,
    },
  },
  doublePica: {
    groupA: {
      fontSize: 20,
      lineHeight: 28,
    },
    groupB: {
      fontSize: 20,
      lineHeight: 28,
    },
    groupD: {
      fontSize: 24,
      lineHeight: 36,
    },
  },
  greatPrimer: {
    groupA: {
      fontSize: 16,
      lineHeight: 22,
    },
    groupB: {
      fontSize: 18,
      lineHeight: 26,
    },
    groupD: {
      fontSize: 20,
      lineHeight: 28,
    },
  },
  bodyCopy: {
    groupA: {
      fontSize: 15,
      lineHeight: 22,
    },
    groupB: {
      fontSize: 16,
      lineHeight: 28,
    },
    groupD: {
      fontSize: 18,
      lineHeight: 30,
    },
  },
  pica: {
    groupA: {
      fontSize: 15,
      lineHeight: 22,
    },
    groupB: {
      fontSize: 16,
      lineHeight: 24,
    },
    groupD: {
      fontSize: 16,
      lineHeight: 22,
    },
  },
  longPrimer: {
    groupA: {
      fontSize: 15,
      lineHeight: 21,
    },
    groupB: {
      fontSize: 15,
      lineHeight: 26,
    },
    groupD: {
      fontSize: 16,
      lineHeight: 26,
    },
  },
  brevier: {
    groupA: {
      fontSize: 14,
      lineHeight: 20,
    },
    groupB: {
      fontSize: 14,
      lineHeight: 20,
    },
    groupD: {
      fontSize: 14,
      lineHeight: 18,
    },
  },
  minion: {
    groupA: {
      fontSize: 12,
      lineHeight: 16,
    },
    groupB: {
      fontSize: 12,
      lineHeight: 16,
    },
    groupD: {
      fontSize: 14,
      lineHeight: 18,
    },
  },
};

export default devanagari;
